import { render } from "./InventoryCreate.vue?vue&type=template&id=55a13c16"
import script from "./InventoryCreate.vue?vue&type=script&lang=js"
export * from "./InventoryCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__